import React, { Component } from 'react';
import { Row, Divider, message } from 'antd';
import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../_actions/user';

import LoginForm from '../components/LoginForm';

class Login extends Component {

    componentWillReceiveProps(props) {
        props.error && message.error(props.error, 2)
    }

    handleSubmit = ({ username, password }) => {
        this.props.userAuthenticate(username, password)
    }

    render() { 
        const { loading } = this.props;
        return <div className={'page'}>
            <Helmet>
                <title>Вход в систему</title>
            </Helmet>

            <div className={'login-wrapper'}>
                <div className={'login-form'}>
                    
                    <LoginForm 
                        onSubmit={this.handleSubmit} 
                        loading={loading}
                        // defaults={{
                        //     username: 'awast07@mail.ru',
                        //     password: 'Cf76STs8H5'
                        // }}
                    />
                
                </div>
            </div>

        </div>
    }
};

const mapStateToProps = (state) => {
    const { loading, error } = state.user;
    return {
        loading,
        error
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(userActions, dispatch)
};
 
export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/pages/Login.jsx